import { Box, CardMedia, Grid, useMediaQuery } from "@mui/material";
import BackroundImg from "../../assets/loginBack.png";
import LogoWhite from "../../assets/logoWhite.png";

const LeftSidContainer = () => {
    const matches = useMediaQuery('(min-width:900px)');
    return (
        <>
            {matches && (
                <Grid item xs={12} md={6} style={{ position: 'relative' }}>
                    <CardMedia
                        component="img"
                        image={BackroundImg}
                        alt="Background Image"
                        style={{
                            height: '100%',
                            width: '100%',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            // zIndex: -1
                            zIndex:1,
                        }}
                    />
                    <Box
                        style={{
                            height: '100%',
                            width: '100%',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 1
                        }}
                    >
                        <CardMedia
                            component="img"
                            image={LogoWhite}
                            alt="Logo Image"
                            style={{
                                maxHeight: '35%', // Adjust as needed
                                maxWidth: '35%'  // Adjust as needed
                            }}
                        />
                    </Box>
                </Grid>
            )}
        </>
    )
}

export default LeftSidContainer; 